export const STORAGE_KEYS = {
  HEALTH_ASSESSMENT_RESULTS: 'health-assessments-results',
  HEALTH_ASSESSMENT_RESPONSES: 'health-assessments-responses',
  AI_ASSESSMENT_SUMMARY: 'health-assessment-ai-summary',
  ASSESSMENT_CHAT_LOCKS: 'assessment_chat_locks_v1',
  HEALTH_ACTIONS: 'eir-health-actions',
  HEALTH_MEMORY_ITEMS: 'eir-health-memory-items',
  HEALTH_MEMORY_ENCRYPTION_KEY: 'eir-health-memory-key-v1',
  CHAT_THREADS: 'eir-chat-threads',
  JOURNAL_NOTES: 'eir-journal-notes',
  CHAT_JOURNAL: 'eir-chat-journal',
  EIR_FILE_CONTENT: 'eir-file-content',
  EIR_DATA_PARSED: 'eir-data-parsed',
  CHAT_MESSAGES: 'eir-chat-messages',
  HEALTH_ANALYSIS: 'eir-health-analysis',
  HEALTH_ANALYSIS_META: 'eir-health-analysis-meta',
  CALENDAR_EVENTS: 'eir-calendar-events',
  CALENDAR_SUGGESTIONS: 'eir-calendar-suggestions',
  FOR_YOU_ITEMS: 'eir-for-you-items',
  USER_PROFILE: 'eir-user-profile',
  ONBOARDING_PENDING: 'eir-onboarding-complete-pending',
  TRIGGER_ONBOARDING: 'eir-trigger-personalized-onboarding',
  NUTRITION_MEAL_LOG: 'eir-nutrition-meal-log',
  USER_CREATED_CBT_PROGRAMS: 'user-created-cbt-programs',
  CHAT_HEALTH_ACTIONS: 'eir-chat-health-actions',
  CBT_MODULE_COMPLETION: 'cbt-module-completion-message',
  CARE_REQUEST_DRAFTS: 'eir-care-request-drafts',
} as const;
